import musicQualification from './music-qualification';

export default {
  namespaced: true,
  state: {
    _moduleKey: 'qualification',
  },
  modules: {
    musicQualification,
  },
};
